import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, DOCUMENT, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private document = inject<Document>(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  private gtmService = inject(GoogleTagManagerService);
  private router = inject(Router);

  init() {
    this.trackInitOriginalLocation();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const isPortrait = window.matchMedia('(orientation: portrait)').matches;

        const gtmTag = {
          event: 'virtualPageview',
          virtualPageURL: event.url,
          virtualPageTitle: this.document.title,
          orientation: isPortrait ? 'Portrait' : 'Landscape',
          devicePixelRatio: window.devicePixelRatio,
        };

        this.gtmService.pushTag(gtmTag).catch(() => {});
      }
    });
  }

  trackInitOriginalLocation() {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    const gtmTag = {
      originalLocation:
        this.document.location.protocol +
        '//' +
        this.document.location.hostname +
        this.document.location.pathname +
        this.document.location.search,
    };

    this.gtmService.pushTag(gtmTag).catch(() => {});
  }
}
